import "./index.scss";
import { useCallback, useState } from "react";
import { ReactComponent as MenuIcon } from "assets/menu-icon.svg";
import { MenuCart, NavbarSearch } from "..";
import { GcxLogo } from "components/UI/molecules/gcx-logo";
import { useWindowDimensions } from "hooks/useWindowDimensions";
import { MenuOverlay, NavbarItem } from "components/UI/molecules";
import { useAppContext } from "context/app-context";

export const MobileNavbar = ({
  isHomePage = false,
  isTopScreen = false,
  leftSideItems,
  menuItems
}) => {
  const { sessionInfo } = useAppContext();
  const [isOpen, setIsOpen] = useState(false);
  const [brands, setBrands] = useState([]);
  const { width } = useWindowDimensions();

  const handleBrandsChange = useCallback((brandsChanged) => {
    setBrands(brandsChanged);
  }, []);

  const toggleMenu = () => {
    setIsOpen((currentState) => !currentState);
  };

  const closeMenu = () => {
    setIsOpen(false);
  };

  const shouldDisplayIcon = width <= 768;
  const shouldDisplayLeftMenu = width >= 980;
  const isLoggedIn = sessionInfo && sessionInfo.isLoggedIn;

  return (
    <div
      className={`mobile-navbar ${isTopScreen && "isTopScreen"}`}
      data-testid="mobile-navbar"
    >
      <div className="left-section">
        <GcxLogo
          data-testid="logo-small"
          version={shouldDisplayIcon ? "icon" : "small"}
        />
        {!isHomePage && (
          <NavbarSearch brands={brands} onBrandsChange={handleBrandsChange} />
        )}
        {shouldDisplayLeftMenu &&
          leftSideItems.map((item) => (
            <NavbarItem
              label={item.label}
              path={item.path}
              logId={item.logId}
              key={item.logId}
            />
          ))}
      </div>
      <div className="menu-actions">
        <MenuCart />
        <button
          className="toggle-button"
          data-testid="toggle-button"
          onClick={toggleMenu}
        >
          <MenuIcon />
        </button>
      </div>
      <MenuOverlay
        isLoggedIn={isLoggedIn}
        isOpen={isOpen}
        onClick={closeMenu}
        items={menuItems}
      />
    </div>
  );
};
